(function () {
  function initReveals(root) {
    if (!("IntersectionObserver" in window)) {
      root.querySelectorAll(".reveal").forEach(function (el) {
        el.classList.add("visible");
      });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    root.querySelectorAll(".reveal").forEach(function (el) {
      observer.observe(el);
    });
  }

  function initFaq(root) {
    root.querySelectorAll(".dona-flip-faq .faq-q").forEach(function (button) {
      if (button.dataset.donaBound === "1") return;
      button.dataset.donaBound = "1";
      button.addEventListener("click", function () {
        var item = button.closest(".faq-item");
        if (item) item.classList.toggle("open");
      });
    });
  }

  function initCountdown(root) {
    root.querySelectorAll("[data-dona-countdown]").forEach(function (node) {
      if (node.dataset.donaCountdownBound === "1") return;
      node.dataset.donaCountdownBound = "1";

      var key = "dona_cd_end_" + (node.dataset.countdownKey || "global");
      var end = parseInt(sessionStorage.getItem(key) || "0", 10);
      if (!end || end < Date.now()) {
        end = Date.now() + (47 * 60 + 23) * 1000;
        sessionStorage.setItem(key, String(end));
      }

      var h = node.querySelector(".cd-h");
      var m = node.querySelector(".cd-m");
      var s = node.querySelector(".cd-s");

      function tick() {
        var diff = Math.max(0, end - Date.now());
        var hh = Math.floor(diff / 3600000);
        var mm = Math.floor((diff % 3600000) / 60000);
        var ss = Math.floor((diff % 60000) / 1000);
        if (h) h.textContent = String(hh).padStart(2, "0");
        if (m) m.textContent = String(mm).padStart(2, "0");
        if (s) s.textContent = String(ss).padStart(2, "0");
        if (diff > 0) setTimeout(tick, 1000);
      }
      tick();
    });
  }

  function initViewers(root) {
    root.querySelectorAll("[data-dona-viewers]").forEach(function (el) {
      if (el.dataset.donaViewersBound === "1") return;
      el.dataset.donaViewersBound = "1";
      (function flicker() {
        el.textContent = String(Math.floor(Math.random() * 12 + 18));
        setTimeout(flicker, Math.random() * 4000 + 3000);
      })();
    });
  }

  function init(root) {
    initReveals(root);
    initFaq(root);
    initCountdown(root);
    initViewers(root);
  }

  document.addEventListener("DOMContentLoaded", function () {
    init(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    init(event.target);
  });
})();
